// 首页引导弹窗队列：保证“上一个关闭 -> 下一个弹出”
// 用于多个组件分散触发的引导弹窗（未开户/证件完善/适当性/银行卡/升位/OCR/回访等）

class HomePopupQueue {
    constructor() {
        this.vm = null;
        this.active = true;
        this.running = false;

        this.items = [];
        this.registeredIds = new Set();
        this.resolvedIds = new Set();

        // 注册空闲一段时间后再开始，尽量覆盖同页多个组件异步 mounted/created 注册
        this.registrationIdleMs = 300;
        this._startTimer = null;
    }

    setVm(vm) {
        this.vm = vm;
    }

    setActive(active) {
        this.active = active;
    }

    reset() {
        this.vm = null;
        this.active = true;
        this.running = false;
        this.items = [];
        this.registeredIds = new Set();
        this.resolvedIds = new Set();
        if (this._startTimer) {
            clearTimeout(this._startTimer);
            this._startTimer = null;
        }
    }

    addStep(step) {
        if (!step || !step.id) return;
        if (this.registeredIds.has(step.id) || this.resolvedIds.has(step.id)) return;
        this.registeredIds.add(step.id);
        this.items.push(step);
        this._scheduleStart();
    }

    _scheduleStart() {
        if (this._startTimer) clearTimeout(this._startTimer);
        this._startTimer = setTimeout(() => {
            this._startTimer = null;
            this.startInternal();
        }, this.registrationIdleMs);
    }

    async startInternal() {
        if (this.running || !this.active) return;
        if (!this.vm) return;

        this.running = true;

        const steps = [...this.items].sort((a, b) => {
            const ao = typeof a.order === "number" ? a.order : 999;
            const bo = typeof b.order === "number" ? b.order : 999;
            return ao - bo;
        });

        for (const step of steps) {
            if (!this.active) break;
            if (this.vm && this.vm.$route && this.vm.$route.name !== "home") break;

            let should = true;
            if (typeof step.shouldShow === "function") {
                try {
                    should = await step.shouldShow(this.vm);
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error("[homePopupQueue] shouldShow error:", step.id, e);
                    should = false;
                }
            }
            if (!should) continue;

            try {
                await step.show(this.vm);
                // 等待一次渲染/路由更新，避免某些 step 内部触发跳转时下一步被抢先弹出
                await new Promise((resolve) => {
                    if (this.vm && typeof this.vm.$nextTick === "function") {
                        this.vm.$nextTick(() => resolve());
                    } else {
                        resolve();
                    }
                });

                if (this.vm && this.vm.$route && this.vm.$route.name !== "home") break;

                this.resolvedIds.add(step.id);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error("[homePopupQueue] show error:", step.id, e);
            }
        }

        this.running = false;
    }
}

let singleton = null;
export function getHomePopupQueue() {
    if (!singleton) singleton = new HomePopupQueue();
    return singleton;
}

export function resetHomePopupQueue() {
    if (singleton) singleton.reset();
}

